import type { AxiosError } from 'axios';
import Axios, { isAxiosError } from 'axios';
import getCookie from '../../utils/getCookie';
import handleAPIPermissionError from '../../utils/handleAPIPermissionError';
import { enqueueSnackbar } from 'notistack';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const apiClient = Axios.create({
  withCredentials: true,
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-CSRFToken': getCookie('csrftoken'),
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (
      isAxiosError(error) &&
      error?.response &&
      error?.response?.status === 403
    ) {
      enqueueSnackbar(
        (error?.response?.data as { detail?: string })?.detail ??
          'Access denied',
        {
          variant: 'error',
          autoHideDuration: 3500,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
        }
      );
      return error;
    }
    if (
      isAxiosError(error) &&
      error?.response &&
      error?.response?.status >= 500
    ) {
      handleAPIPermissionError(error);
    }
    return error;
  }
);
